import React, { useState, useEffect } from "react";
import axiosInstance from "../utills/axiosInstance";
import './Offboarding.css';

const RMApprovalDashboard = () => {
    const [requests, setRequests] = useState([]);

    useEffect(() => {
        axiosInstance.get(`/api/pending`).then(res => setRequests(res?.data));
    }, []);

    const handleDecision = async (id, approve) => {
        const remarks = prompt(approve ? "Enter approval remarks (optional):" : "Enter rejection reason:");
        if (remarks === null) return;

        try {
            const res = await axiosInstance.put(`/api/rm-approve/${id}`, { approve, remarks });
            setRequests(prev => prev.map(r => r._id === id ? res.data : r));
            alert(approve ? "Approved!" : "Rejected!");
        } catch (err) {
            alert("Error processing request");
        }
    };

    return (
        <div className="app-container">
            <div className="header-section">
                <h2 className="page-title">Offboarding Requests - Reporting Manager</h2>
            </div>

            <div className="upload-form">
                {requests?.length === 0 ? (
                    <p className="text-center text-gray-600 py-10">No pending requests for approval</p>
                ) : (
                    requests?.map(req => (
                        <div key={req._id} className="form-section mb-6 border-l-4 border-yellow-500">
                            <div className="flex justify-between items-start">
                                <div>
                                    <h3 className="font-bold text-lg">{req.employee.firstName} {req.employee.lastName}</h3>
                                    <p className="text-sm text-gray-600">{req.employee.empId} • {req.employee.department}</p>
                                    <p className="mt-3"><strong>Reason:</strong> {req.reasonForLeaving} {req.otherReason}</p>
                                    <p><strong>Last Working Day:</strong> {new Date(req.lastWorkingDay).toLocaleDateString()}</p>
                                </div>
                                <div className="flex gap-3">
                                    <button onClick={() => handleDecision(req._id, true)} className="btn btn-primary">
                                        Approve
                                    </button>
                                    <button onClick={() => handleDecision(req._id, false)} className="btn bg-red-600 hover:bg-red-700">
                                        Reject
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default RMApprovalDashboard;
